/**
 *
 * DownloadPdfButton
 *
 */

import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import _classNames from 'classnames';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import _get from 'lodash/get';
import useSiteCopySelector from 'components/useSiteCopySelector';
import AssessmentResultContext from 'containers/AssessmentResult/AssessmentResultContext';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import {
  makeSelectClientDetails,
  makeSelectClinicMode,
} from 'containers/Main/selectors';
import MixPanel, { injectAssessmentResultsABData } from 'utils/mixpanelService';
import { isWebView } from 'utils/embedded';
import { downloadPagePdf } from '../utils';

const useStyles = makeStyles(theme => ({
  button: {
    display: 'flex',
    padding: '12px 40px',
    borderRadius: 4,
    justifyContent: 'center',
    marginLeft: 8,
    marginRight: 8,
    textTransform: 'none',
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
      width: '100%',
      marginTop: 16,
    },
    ...theme.typography.caption,
  },
  tight: {
    padding: '10px 15px',
    minWidth: 'unset',
    fontSize: '0.875rem',
  },
}));

function DownloadPdfButton({
  answer,
  handlePdfContent,
  tight = false,
  variant = 'outlined',
}) {
  const classes = useStyles();
  const clientDetails = useSelector(makeSelectClientDetails());
  const clinicMode = useSelector(makeSelectClinicMode());
  const { isVariantB, shouldABTest } = useContext(AssessmentResultContext);
  const hideDownloadPdfButton =
    _get(clientDetails, 'metadata.hidePdfDownloadButton', false) ||
    clinicMode ||
    isWebView();
  const [assessmentResultsSiteCopy] = useSiteCopySelector([
    'assessment-results',
  ]);
  const { slug } = useParams();

  const assessmentID = _get(answer, 'assessment.assessmentID', '');
  const name = _get(answer, 'assessment.name', '');

  const handlePdfDownload = async () => {
    handlePdfContent(true);
    MixPanel.track(
      'Download PDF',
      injectAssessmentResultsABData(
        {
          path: window.location.pathname,
          type: 'assessment',
          slug,
          name,
          assessmentId: assessmentID,
          overallResultId: _get(answer, 'resultID.overall', null),
          source: 'action-buttons',
        },
        shouldABTest,
        isVariantB,
      ),
    );
    await downloadPagePdf(slug);
    handlePdfContent(false);
  };

  if (hideDownloadPdfButton) return null;

  return (
    <Button
      variant={variant}
      color="primary"
      className={_classNames(classes.button, { [classes.tight]: tight })}
      onClick={handlePdfDownload}
    >
      {_get(assessmentResultsSiteCopy, 'pageCopy.downloadResultsLabel')}
    </Button>
  );
}

DownloadPdfButton.propTypes = {
  answer: PropTypes.object,
  handlePdfContent: PropTypes.func,
};

export default DownloadPdfButton;
